import { Box, getThemeColor, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Header = styled(Box)`
  padding: ${({ theme }) => getThemeSpacing(3, theme)};
  gap: ${({ theme }) => getThemeSpacing(3, theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  align-items: center;
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  width: 100%;
`
